module.exports = __webpack_public_path__ + "static/c931d855-1587-44c6-8cb1-23952599c1d1-47bf57db134485990cedd97b254251b7.jpg";